'use strict';

import { addPoiToIntersection, hidePOILabelsByDistance, poiIntersection, poiToggle } from '../../poi/poiCss';
import { createHtmlElement, rgbaToHexA } from '../../../functions';
import { setLordIcon } from '../../../lordicon';
import {changeLangToCurrent} from "../langSwitcher/langSwitcher";
import { GoogleMaps } from '../../api/GoogleMaps';
import { Route } from '../../poi/Route';
import { settingsData, threeJsVariables } from '../../../settings';
import { Orbit360 } from './Orbit360';
import {Group, Vector3} from "three";
import {Deals} from "./Deals";
import { Objects } from '../../threejs/Objects/Objects';
import { ViewMode } from '../../../common';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';


export class PoiLayer extends Route{

    constructor (parent) {
        super();
        this.active = false;
        this.type = 'poi';
        this.id = 'poi';
        this.iconColors = {};
        this.route = null;
        this.btn = createHtmlElement('','','button',['public-layer__btn',`poi`]);
        this.btn.setAttribute('data-public-layer','poi');
        parent.insertAdjacentElement('afterbegin', this.btn);

        this.#getIconColors();
        setLordIcon('map',this.btn,{
            trigger: 'hover',
            stroke: 70
        });

        this.btnText = createHtmlElement(this.btn,'','span',['public-layer__btn-text', 'language-string']);
        this.btnText.setAttribute('data-dictionary', 'Popular');
        this.btnText.innerHTML = changeLangToCurrent('Popular');
        this.btn.addEventListener('mouseover', this.mouseOverHandler.bind(this));
        this.btn.addEventListener('mouseout', this.mouseOutHandler.bind(this));

        const orbit360Data = config.features.publicLayers.layers.find(layer => layer.type === '360');
        if (orbit360Data && !Objects.useLabelsFromBundle) {
            this.orbit360Points = new Orbit360(document.querySelector('.public-layers__elements'),orbit360Data);
            this.orbit360Points.then(labels => {
                const group = threeJsVariables.scene.getObjectByName('Poi group');
                group.add(...labels);
                labels.forEach(label => addPoiToIntersection(label));
                poiIntersection();
            });
        }

        const dealsData = config.features.publicLayers.layers.find(layer => layer.type === 'deals');
        if (dealsData && dealsData.active) {
            const deals = new Deals(document.querySelector('.public-layers__elements'), dealsData);
            deals.then(labels => {
                const rotation = new Vector3();
                if (config.features.poi.rotation) {
                    rotation.set(
                      config.features.poi.rotation.x,
                      config.features.poi.rotation.y,
                      config.features.poi.rotation.z
                    )
                } else {
                    rotation.y = config.threejs.compass.correction - Math.PI / 2;
                }

                const position = config.features.poi.position || {x: 0, y: 0, z: 0};
                const dealsGroup = new Group();
                dealsGroup.name = 'Deals group';
                dealsGroup.rotation.setFromVector3(rotation);
                dealsGroup.position.set(position.x, 0, position.z);

                threeJsVariables.scene.add(dealsGroup);
                threeJsVariables.renderList.reorder();

                dealsGroup.add(...labels);
                labels.forEach(label => addPoiToIntersection(label));
                poiIntersection();
            });

            const {primary,secondary} = config.features.icons.color;

            const primaryRgba = config.style.colors.find(color => color.key === primary) || { value: '255,255,255,1' };
            const secondaryRgba = config.style.colors.find(color => color.key === secondary) || { value: '255,255,255,1' };
            const activeRgba = config.style.colors.find(color => color.key === 'brand2');

            const primaryColor = rgbaToHexA(primaryRgba.value.split(','),false);
            const secondaryColor = rgbaToHexA(secondaryRgba.value.split(','),false);
            const activeColor = rgbaToHexA(activeRgba.value.split(','), false);

            const dealsButtonElement = document.querySelector('.public-layer__btn.deals');
            dealsButtonElement.setAttribute('state', 'non-pressed');
            dealsButtonElement.addEventListener('mouseover', () => {
                const state = dealsButtonElement.getAttribute('state');
                if (state === 'pressed')
                    return;

                const icon = dealsButtonElement.querySelector('.lord__icon');
                icon.setAttribute('colors',`primary:${activeColor},secondary:${activeColor}`);
                dealsButtonElement.style.color = activeColor;
            });
            dealsButtonElement.addEventListener('mouseout', () => {
                const state = dealsButtonElement.getAttribute('state');
                if (state === 'pressed')
                    return;

                const icon = dealsButtonElement.querySelector('.lord__icon');
                icon.setAttribute('colors',`primary:${primaryColor},secondary:${secondaryColor}`);
                dealsButtonElement.style.color = '';
            });
        }
    }

    mouseOverHandler() {
        !this.active && this.enable();
    }

    mouseOutHandler() {
        !this.active && this.disable();
    }

    publicButtonHandler() {
        if (this.active) {
            this.hide();
        } else {
            this.show();
        }
    }

    #getIconColors() {
        const {primary,secondary} = config.features.icons.color;

        const primaryRgba = config.style.colors.find(color => color.key === primary) || { value: '255,255,255,1' };
        const secondaryRgba = config.style.colors.find(color => color.key === secondary) || { value: '255,255,255,1' };
        const activeRgba = config.style.colors.find(color => color.key === 'brand2');

        this.iconColors.primaryColor = rgbaToHexA(primaryRgba.value.split(','),false);
        this.iconColors.secondaryColor = rgbaToHexA(secondaryRgba.value.split(','),false);
        this.iconColors.activeColor = rgbaToHexA(activeRgba.value.split(','), false);
    }

    show() {
        if (threeJsVariables.cssLabelManager.isBlocked(this.id))
            return;
        if (settingsData.activeViewMode === ViewMode.Orbit) {
            this.active = true;
            poiToggle(true,true);
            Objects.visibilityCSSLabels(true);
            this.enable();
            if (!OrbitDayAndNight.isActiveAndSelected) {
                this.hideLabelsByDistance(true);
            }
        }
    }
    
    hideLabelsByDistance(state) {
        // hidePOILabelsByDistance(state);
    }

    hide() {
        if (threeJsVariables.cssLabelManager.isBlocked(this.id))
            return;
        this.active = false;
        poiToggle(false,false);
        Objects.visibilityCSSLabels(false);
        this.removeRoute();
        this.disable();
    }

    removeRoute(){
        super.removeRoute();
        this.route = null;
    }

    disable() {
        if (this.btn) {
            const icon = this.btn.querySelector('.lord__icon');
            icon.setAttribute('colors',`primary:${this.iconColors.primaryColor},secondary:${this.iconColors.secondaryColor}`);
            this.btn.style.color = '';
        }
    }

    enable() {
        if (this.btn) {
            const icon = this.btn.querySelector('.lord__icon');
            icon.setAttribute('colors',`primary:${this.iconColors.activeColor},secondary:${this.iconColors.activeColor}`);
            this.btn.style.color = this.iconColors.activeColor;
        }
    }

    tick(delta) {
        this.route && this.route.tick(delta);
    }

    update(delta) {
        this.route && this.route.tick(delta);
    }

    async drawRoute(poiMarker,order) {

        this.removeRoute();

        let route;

        if (poiMarker.data.routeResponce.DRIVING) {
            route = poiMarker.data.routeResponce.DRIVING;
        } else {

          const from = {
            lat: Number(config.localization.latitude),
            lng: Number(config.localization.longitude)
          };

          const to = {
            lat: poiMarker.position.lat(),
            lng: poiMarker.position.lng()
          };

          route = await GoogleMaps.getRoute(from,to);
          poiMarker.data.routeResponce.DRIVING = route;
        }

        this.route = super.drawRoute(route,order);
    }

}
